module.exports = __webpack_public_path__ + "static/media/scanner.e05b3429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/scanner.png
// module id = 572
// module chunks = 0